import "./style"
import Ckeditor from "ckeditor/editor"
import {Input} from "@kaspernj/api-maker/src/inputs/input"
import InputContainer from "components/inputs/input-container"

const ComponentsInputsInput = memo(shapeComponent(class ComponentsInputsInput extends ShapeComponent {
  static defaultProps = {
    resize: "vertical"
  }

  static propTypes = {
    resize: PropTypes.string.isRequired
  }

  render() {
    const {className, hint, resize, ...restProps} = this.props
    const {inputProps, wrapperOpts} = useInput({props: this.props})

    if (inputProps.type == "ckeditor") {
      const {ref, type, ...restCkeditorProps} = inputProps

      return (
        <Ckeditor
          inputRef={ref}
          onChange={restProps.onChange}
          resource={this.props.resource || this.props.model}
          resourceId={restProps.resourceId}
          resourceType={restProps.resourceType}
          {...restCkeditorProps}
        />
      )
    }

    return (
      <Input
        className={classNames("components--inputs--input", className)}
        data-invalid={wrapperOpts.errors?.length > 0}
        data-resize={restProps.type == "textarea" && resize}
        inputProps={inputProps}
        placeholder={wrapperOpts.placeholder}
        wrapperOpts={wrapperOpts}
        {...restProps}
      />
    )
  }
}))

const ComponentsInputsInputWithContainer = memo((props) => {
  const {inputProps, restProps, wrapperOpts} = useInput({props, wrapperOptions: {type: "input"}})

  return (
    <InputContainer hint={restProps.hint} inputProps={inputProps} wrapperOpts={wrapperOpts}>
      <ComponentsInputsInput {...props} />
    </InputContainer>
  )
})

export default ComponentsInputsInputWithContainer
